import { render, staticRenderFns } from "./NkUpsLine.vue?vue&type=template&id=a664dfe2&scoped=true"
import script from "./NkUpsLine.vue?vue&type=script&lang=js"
export * from "./NkUpsLine.vue?vue&type=script&lang=js"
import style0 from "./NkUpsLine.vue?vue&type=style&index=0&id=a664dfe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a664dfe2",
  null
  
)

export default component.exports